import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  Input,
  Output,
} from '@angular/core';
import { CULTURE_ROUTE_PARAM } from '@constants/app.constants';
import { LetDirective } from '@directives/app-let.directive';
import { Store } from '@ngrx/store';
import {
  SafeHtmlPipe,
  SanitizerValueType,
} from '@pipes/safe-html/safe-html.pipe';
import { selectRouteParam } from '@selectors/router.selector';

@Component({
  selector: 'app-verified-by-norse-modal-variant-c',
  standalone: true,
  imports: [CommonModule, SafeHtmlPipe, LetDirective],
  templateUrl: './verified-by-norse-modal-variant-c.component.html',
  styleUrl: './verified-by-norse-modal-variant-c.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VerifiedByNorseModalVariantCComponent {
  @Input() header: string;
  @Input() verifiedTitleOne: string;
  @Input() verifiedTitleTwo: string;
  @Input() verifiedTitleThree: string;
  @Input() verifiedAcknowledgement: string;
  @Output() closeClick = new EventEmitter<void>();

  readonly SanitizerValueType = SanitizerValueType;

  private store = inject(Store);

  culture$ = this.store.select(selectRouteParam(CULTURE_ROUTE_PARAM));

  onCloseClick(): void {
    this.closeClick.emit();
  }
}
